// extracted by mini-css-extract-plugin
export default {"table":"LiveSupport_table__zT2Zq","header":"LiveSupport_header__bngET","row":"LiveSupport_row__B2W0+","unread_row":"LiveSupport_unread_row__5pmGh"};